export default __webpack_public_path__ + "images/JD.0653ef5.png";